/*
 * This file is used to import all the offer flow contents and export them as an array.
 *
 */

const context: Record<string, { default: OfferFlowContent }> = import.meta.glob('./offerFlowContent*.ts', { eager: true });
export const offerFlowContents = Object.values(context).map<OfferFlowContent>(c => c.default);
export default offerFlowContents;
